import { useQuery } from '@tanstack/react-query';

import { GetSubscriptionTagsInfoResponse } from '@/api/subscriptionTags/types';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { SUBSCRIPTION_TAGS_INFO_QUERY_KEY } from '@/config';

export const TRANSITIONING_POLL_MS = 1000 * 30; // 30 seconds
const DEFAULT_STALE_MS = 1000 * 60 * 5; // 5 minutes

export const getSubscriptionTagsInfo = async (options?: RequestOptions): Promise<GetSubscriptionTagsInfoResponse> => {
    return axios.get<GetSubscriptionTagsInfoResponse, GetSubscriptionTagsInfoResponse>(
        '/api/v2/subscription-tags',
        options
    );
};

type UseSubsciptionsInfoOptions = {
    config?: QueryConfig<typeof getSubscriptionTagsInfo>;
};

const hasTransitioningTelemetry = (data?: GetSubscriptionTagsInfoResponse) =>
    Boolean(data?.data.some(({ iridium_network_status }) => iridium_network_status?.endsWith('ING')));

export const useSubscriptionTagsInfo = ({ config }: UseSubsciptionsInfoOptions = {}) =>
    useQuery<GetSubscriptionTagsInfoResponse>({
        ...config,
        queryKey: [SUBSCRIPTION_TAGS_INFO_QUERY_KEY],
        queryFn: ({ signal }) => getSubscriptionTagsInfo({ signal }),
        staleTime: DEFAULT_STALE_MS,
        refetchInterval: ({ state }) => (hasTransitioningTelemetry(state.data) ? TRANSITIONING_POLL_MS : false),
    });
